module.exports = __webpack_public_path__ + "img/9_no.66bf623d.svg";